import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useIdioma } from "@/context/IdiomaContext";

export const PieLegal = ({ className = "" }) => {
  const { idioma } = useIdioma();
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/publico/legal`, { params: { idioma } })
      .then(({ data }) => setDocs(data)).catch(() => setDocs([]));
  }, [idioma]);

  return (
    <footer className={`border-t border-border mt-16 py-8 ${className}`} data-testid="pie-legal">
      <div className="max-w-6xl mx-auto px-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} BSpark Family Hub</span>
        {docs.map((d) => (
          <Link key={d.slug} to={`/legal/${d.slug}`} className="hover:text-foreground transition-colors duration-200"
            data-testid={`pie-legal-${d.slug}`}>
            {d.titulo}
          </Link>
        ))}
      </div>
    </footer>
  );
};
